import IconAction from "~/ui/icon-action";
import { _, Notifications } from "~/route/globals";
import MyMapsShare from "~/es6/mymaps.share";
import { MAX_URL_LENGTH } from "~/util/constants";
import { node } from "~/util/dom";
import { ROUTE_CONST } from "~/route/const";
import { getModulesData, getExportState } from "~/route/utils";
import { NOTIFICATIONS_TYPE } from "~/util/notifications";
import MyMapsMapyBoxItem from "~/ui/dialogs/mymaps-mapybox-item";
import { getCreateLikeData, mapyboxAnalyticsSave } from "~/util/mapybox";
import { getFolderData } from "~/util/providers/mapybox";
import { getNoteVersion, isPremiumNoteUser } from "~/util/user-note";
import MyMapsExport from "~/ui/dialogs/mymaps-export";
import { MYMAPS_SHARE } from "~/ui/sds-compatible-icons";

export function createSummaryActions(responseData, routeState) {
	const container = node("div", { className: "route-actions" });
	const saveTitle = _("action.save.title");

	const save = new IconAction({
		icon: "star-line",
		title: saveTitle,
		log: false,
		callback: () => {
			if (routeState.params.useTraffic && routeState.lastRouteDate > 0 && routeState.lastRouteDate < Date.now() - (1000 * 60 * 60)) {
				Notifications.notify({
					content: _("route3.error.410"),
					type: NOTIFICATIONS_TYPE.SUCCESS,
				});

				Mapy.CML.state = {
					route: {
						forced: true,
						reroute: true,
					},
				};

				return;
			}

			const saveData = getModulesData();
			const actualRouteState = Mapy.CML.state.route;
			const likeData = actualRouteState.likeData;
			const isReplace = likeData && "parent_name" in likeData;
			const folderData = getFolderData();

			if (!isReplace) {
				Mapy.getComponent("logger").log("click", {
					text: "uložit_hvězda",
					type: "route",
				});
			}

			new MyMapsMapyBoxItem({
				isPremiumUser: isPremiumNoteUser(),
				noteVersion: getNoteVersion(),
				// @ts-ignore
				createData: getCreateLikeData({
					...saveData,
					...likeData && "linktype" in likeData ? { linktype: likeData.linktype } : {},
					// eslint-disable-next-line camelcase
					...likeData && "user_time" in likeData ? { user_time: likeData.user_time } : {},
				}, "route"),
				...folderData
					? {
						folder: folderData,
					}
					: {},
				...isReplace
					? {
						mode: actualRouteState.likeDataChange
							? "replace"
							: "save-as-new",
						likeData: likeData,
						folder: {
							id: likeData.parent_id,
							title: likeData.parent_name,
						},
					}
					: {
						mode: "create",
					},
				onSave: ({ likeData: newLikeData }) => {
					Mapy.getComponent("logger").log("click", {
						type: "route",
						origin: "web",
					});

					if (!isReplace) {
						const isTrip = actualRouteState.items.length ? !!actualRouteState.items[0].tripData[actualRouteState.index] : false;

						mapyboxAnalyticsSave({
							type: isTrip ? "circuit" : "route",
							note: !!newLikeData.description,
							...isTrip
								? {
									routeType: actualRouteState.params.tripCriterion,
								}
								: {},
						});
					}

					Mapy.CML.state = {
						route: {
							likeData: {
								...newLikeData,
								title: saveData.title,
								subtitle: saveData.subtitle,
								data: {
									route: JSON.parse(JSON.stringify(saveData.items)),
									totalLength: saveData.totalLength,
									totalTime: saveData.totalTime,
								},
							},
							likeDataChange: false,
						},
					};

					save.props = Object.assign(save.props, { change: false, title: _("action.save.title") });

					Mapy.getComponent("dimcurator").setState({ dim: newLikeData.id }).loadData().then(() => {
						Mapy.getComponent("history").save();
					}, () => {});
				},
			}).open();
		},
	});

	const share = new IconAction({
		icon: "",
		sdsIcon: MYMAPS_SHARE,
		title: _("action.share.title"),
		callback: () => {
			if (window.location.toString().length < MAX_URL_LENGTH) {
				const saveData = getModulesData();
				const data = routeState.likeData && !routeState.likeDataChange
					? {
						...routeState.likeData,
						like: !("owner_name" in routeState.likeData),
						showLabel: routeState.likeData && !routeState.likeDataChange,
					}
					: {
						title: saveData.title,
						type: "route",
					};
				const sharePopup = new MyMapsShare(data, cbData => {
					if (cbData.name === "popup-close") {
						if (routeState.likeData && routeState.likeData.public !== cbData.public) {
							Mapy.CML.state = {
								route: {
									likeData: {
										public: cbData.public,
									},
								},
							};
							Mapy.getComponent("places").listRefreshData();
						}
					}
					sharePopup.destroy();
				});

				sharePopup.open();
			} else {
				Notifications.notify({
					type: NOTIFICATIONS_TYPE.ERROR,
					content: _("route.URLTooLong"),
					autohide: true,
					duration: 5000,
				});
			}
		},
	});

	const download = new IconAction({
		icon: "export2",
		title: _("action.download.title"),
		callback: () => {
			const data = getExportState();
			const criterion = data.rp_c[0];

			new MyMapsExport({
				data: {
					name: "route",
					data,
					tponly: ROUTE_CONST.types.car.criterion.indexOf(criterion) !== -1,
				},
				onError: errorData => {
					if (errorData.routeError410) {
						Notifications.notify({
							content: _("route3.error.410"),
							type: NOTIFICATIONS_TYPE.SUCCESS,
						});

						Mapy.CML.state = {
							route: {
								forced: true,
								reroute: true,
							},
						};
					}
				},
			}).open();
		},
	});

	if (routeState.likeDataChange && routeState.likeData && !("owner_name" in routeState.likeData)) {
		Mapy.getComponent("dimcurator").setState();
		save.props = Object.assign(save.props, { change: true, title: _("action.save.changeTitle") });
	}

	container.appendChild(save.container);
	container.appendChild(share.container);
	container.appendChild(download.container);

	return {
		container,
		resetSave: () => {
			save.props = Object.assign(save.props, { change: false, title: _("action.save.title") });
		},
	};
}
